import { createClient } from '@supabase/supabase-js';
import { createPrivateStorageFetch } from './privateStorageFetch';

const supabaseUrl = process.env.REACT_APP_SUPABASE_URL;
const supabaseAnonKey = process.env.REACT_APP_SUPABASE_ANON_KEY;

export const supabase = createClient(supabaseUrl, supabaseAnonKey, { global: { fetch: createPrivateStorageFetch(supabaseUrl) } });
